/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/inbox/bulk/noModification"/>
export class NoModificationError extends Error {};
